import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal } from 'react-bootstrap';

import Actions from './Actions';

export default function UnlockPopup({
  enterprise, onHide, onComplete,
}) {
  const [loader, setLoader] = useState(false);

  const onUnlockClicked = () => {
    setLoader(true);
    Actions.unlock(enterprise.id, () => {
      setLoader(false);
      onComplete();
    });
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          Unlock Enterprise
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <p className="text-danger">{enterprise.attributes.lock_reason_human}</p>
        <p>
          Click "Unlock" to prevent cancellation, or "Close" to exit this window.
        </p>
        <div className="mt50 mb30">
          <Row>
            <Col md={6}>

              <button
                type="button"
                onClick={() => onHide()}
                className="btn btn-primary btn-outline mr5 ml5 width-120"
              >
                Close
              </button>

            </Col>
            <Col md={6} className="text-right">
              <button
                className={`btn width-120 btn-primary submit-button mr5 ml5 ${loader ? 'not-possible-click' : ''}`}
                type="submit"
                onClick={onUnlockClicked}
              >
                Unlock
              </button>

            </Col>
          </Row>
        </div>

      </Modal.Body>
    </>
  );
}

UnlockPopup.propTypes = {
  enterprise: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
};
